'use strict';
import angular from 'angular';
angular.module('eeComUiApp', ['ngMaterial', 'ngMessages']);
var SignupController = /** @class */ (function () {
    /*@ngInject*/
    function SignupController(Auth, $state, $scope, $cookies, $timeout, $q, $window, Util, SignupService, UserService, $mdToast, $mdDialog, Upload, CredentialListService) {
        var _this = this;
        this.audience = 'none';
        this.user = {};
        this.pinfo = {};
        this.credentials = null;
        this.errors = {};
        this.submitted = false;
        this.isAccountFormValid = false;
        this.isProfessionalFormValid = false;
        this.isCertificationFormValid = false;
        this.allPromises = [];
        this.deferred = null;
        this.showAlert = true;
        this.errors = {
            havePageErrors: false, pageErrors: '', pageErrorType: ''
        };
        this.progressBar = false;
        this.loadingBar = false;
        this.message = 'THis is The Test';
        this.formSubmitted = false;
        this.accountCreated = false;
        this.closeAlertMessage = function () {
            this.showAlert = false;
        };
        this.Auth = Auth;
        this.$state = $state;
        this.$scope = $scope;
        this.UserService = UserService;
        this.selectedTab = 0;
        this.$scope.next = false;
        this.signupService = SignupService;
        this.$mdToast = $mdToast;
        this.$mdDialog = $mdDialog;
        this.Upload = Upload;
        this.$cookies = $cookies;
        this.$timeout = $timeout;
        this.$q = $q;
        this.$window = $window;
        this.Util = Util;
        this.CredentialListService = CredentialListService;
        this.showSpinner = false;
        this.$scope.$on('addressTrackingEvent', function (event, data) {
            _this.fireEvent(data.eventName);
        });
        this.$scope.$on('generalInfoTrackingEvent', function (event, data) {
            _this.fireEvent(data.eventName);
        });
        this.$scope.$on('professionalInfoTrackingEvent', function (event, data) {
            _this.fireEvent(data.eventName);
        });
        var self = this;
        //this.$scope.user = {};
        $scope.$watch(function () { return _this.audience; }, function (newVal, oldVal) {
            UserService.setAudience(newVal);
            self.$cookies.put('audience', self.audience); // for confirmation page
        });
        $scope.$on('accountFormValid', function (event, data) {
            self.isAccountFormValid = data;
        });
        //Child component address-form  will send this message.
        $scope.$on('publishedAddress', function (event, data) {
            self.pinfo.billingAddress = data;
            self.user.billingAddress = data;
            self.deferred3.resolve();
        });
        //document.getElementById('ee-chat').style.bottom = "0px";
    }
    SignupController.prototype.logIn = function () {
        this.$window.location = '/auth/ares';
    };
    SignupController.prototype.shouldFormBeDisabled = function () {
        return this.$scope.generalForm.$invalid || this.formSubmitted;
    };
    // When submit form event is triggered by submit button, it will broadcast submitForm event
    // The child component (general-inf) is listening to this event
    SignupController.prototype.submitForm = function ($event) {
        $event.preventDefault();
        if (this.signupService.isMobileDevice()) {
            this.showSpinner = true;
        }
        else {
            this.showSpinner = false;
        }
        this.formSubmitted = true;
        this.$scope.$broadcast('submitForm', {});
    };
    SignupController.prototype.updateCertification = function ($event) {
        this.credentials = $event.credentials;
        this.deferred2.resolve();
    };
    SignupController.prototype.updateProfInfo = function ($event) {
        this.pinfo = $event.pinfo;
        this.deferred1.resolve();
    };
    // This will be called when child component (general-info) form
    // calls this function as specified in parent form when general-info is included
    SignupController.prototype.register = function (event) {
        var self = this;
        self.user = event.user;
        self.submitted = true;
        self.loadingBar = true;
        if (self.audience === 'personal') {
            self.$q.all(self.allPromises).then(function () {
                self.user.accountType = '6';
                //self.user.businessName = self.user.firstName + ' ' + self.user.lastName;
                self.user.businessName = '';
                self.user.address1 = self.user.billingAddress.address1;
                self.user.address2 = self.user.billingAddress.address2;
                self.user.city = self.user.billingAddress.city;
                self.user.state = self.user.billingAddress.state;
                self.user.country = self.user.billingAddress.country;
                self.user.postalCode = self.user.billingAddress.postalCode;
                self.registerAccount();
            });
        }
        else {
            self.$q.all(self.allPromises).then(function () {
                self.user.accountType = '4';
                self.user.businessName = self.pinfo.businessName;
                self.user.phone = self.pinfo.businessPhone;
                self.user.ext = self.pinfo.ext;
                self.user.fax = self.pinfo.fax;
                self.user.address1 = self.pinfo.billingAddress.address1;
                self.user.address2 = self.pinfo.billingAddress.address2;
                self.user.city = self.pinfo.billingAddress.city;
                self.user.state = self.pinfo.billingAddress.state;
                self.user.country = self.pinfo.billingAddress.country;
                self.user.postalCode = self.pinfo.billingAddress.postalCode;
                //TODO ES-2608 adding a temporary workaround to fix registration form submission, by adding
                //credential node to the JSON in request, Existence of credential node should be checked by backend team
                self.user.credentials = [];
                var cred = {};
                // hardcoding the 0th element as doctorTypeID is only mandatory.
                cred.doctorTypeId = self.credentials[0].credentialType !== null ? self.credentials[0].credentialType['doctorTypeID'] : cred.doctorTypeId = "";
                if (self.credentials[0] && self.credentials[0].file) {
                    var reader_1 = new FileReader();
                    reader_1.readAsDataURL(self.credentials[0].file);
                    reader_1.onloadend = function () {
                        // use a regex to remove data url part
                        var base64String = reader_1.result
                            .replace("data:", "")
                            .replace(/^.+,/, "");
                        cred.file = base64String;
                        cred.fileName = self.credentials[0].file.name;
                        cred.fileType = cred.fileName.split('.').pop().toLowerCase();
                        self.user.credentials.push(cred);
                        self.registerAccount();
                    };
                }
                else {
                    self.user.credentials.push(cred);
                    self.registerAccount();
                }
            });
        }
    };
    SignupController.prototype.uploadCredentials = function () {
        var _this = this;
        var self = this;
        if (self.credentials && self.credentials.length) {
            console.log('Found Credentials ->', self.credentials);
            this.CredentialListService.getCredentials().then(function (resp) {
                var previousCredential = [];
                var credential = {
                    credentialId: resp.data[0].credentialId,
                    credentialType: _this.credentials[0].credentialType,
                    id: _this.credentials[0].id,
                    doctorTypeId: _this.credentials[0].credentialType.doctorTypeID,
                    doctorTypeKey: _this.credentials[0].credentialType.doctorTypeKey,
                    file: _this.credentials[0].file
                };
                previousCredential.push(credential);
                self.credentials.splice(0, 1);
                self.upload(self.credentials);
            });
        }
        else {
            console.log('No Found Credentials Finishing up ->');
            self.showSimpleToast('Successful', '');
            self.loadingBar = false;
            self.Util.resetApiError(self);
            // After successful credential upload:
            self.$state.go('signupConfirmed');
        }
    };
    SignupController.prototype.registerAccount = function () {
        var self = this;
        self.$cookies.put('credentialUploaded', 'false'); // for confirmation page
        // If account is already created, then this time just
        // restart failed upload file process
        // @TODO: This feature is currently not fully implemented...
        if (self.accountCreated) {
            self.uploadCredentials();
            return;
        }
        self.signupService.createAccount(this.user).then(function (response) {
            console.log('Account Creation Response Received ->', response);
            if (response.status != 200 || (response.data && response.data.errors && response.data.errors.length)) {
                console.log('Error Here ? ', (response.data && response.data.errors && response.data.errors.length));
                self.formSubmitted = false;
                self.accountCreated = false;
                self.Util.handleApiError(response, self);
            }
            else {
                // Analytics - GTM Integration
                var eventData = self.signupService.signupEvents.practitionerSignUpGTMTrackingEvents['customerSignup'];
                self.signupService.GoogleAnalyticsService.sendGTMEvent(eventData, {
                    practitionerId: response.data.response.customerId,
                    eventTimestamp: Date.now(),
                    practiceType: self.user.credentials[0].doctorTypeId.trim(),
                });
                self.accountCreated = true; // If account created but upload fails, next time do not call createAccount
                self.signupService.getAuthenticated(self.user).then(function (response) {
                    if (response.status != 200 || (response.data && response.data.errors && response.data.errors.length)) {
                        console.log('Error in Authentication User ? ', (response.data && response.data.errors && response.data.errors.length));
                        self.$cookies.put('signupError', 'true');
                        self.$state.go('signupConfirmed');
                    }
                    else {
                        console.log('Success in Authentication User. Uploading Credentials');
                        self.uploadCredentials();
                    }
                });
            }
            self.loadingBar = false;
        });
    };
    SignupController.prototype.showSimpleToast = function (message, addMsg) {
        var msg = (addMsg != null) ? addMsg : '';
        this.$mdToast.show(this.$mdToast.simple()
            .textContent('Account Registration ' + message + ' \n' + msg)
            .position('bottom right')
        //.hideDelay(1000)
        );
    };
    SignupController.prototype.changeAudience = function (audience) {
        var self = this;
        self.formSubmitted = false;
        self.audience = audience;
        self.$cookies.put('audience', self.audience); // for confirmation page
        self.allPromises.length = 0;
        if (self.audience == 'resale') {
            self.deferred1 = this.$q.defer();
            self.deferred2 = this.$q.defer();
            self.deferred3 = this.$q.defer();
            self.allPromises.push(self.deferred1.promise); // for professional info
            // self.allPromises.push(self.deferred2.promise); // for certification. Disabled for now.
            self.allPromises.push(self.deferred3.promise); // for address
        }
        if (self.audience == 'personal') {
            self.deferred3 = this.$q.defer();
            self.allPromises.push(self.deferred3.promise);
        }
        //document.getElementById('ee-chat').style.bottom = "68px";
    };
    SignupController.prototype.nextTab = function (form) {
        if (this.selectedTab > 0) {
            this.register(form);
        }
        else {
            this.selectedTab = (this.selectedTab + 1);
            console.log('new tab');
            this.$window.scrollTo(0, 0);
        }
    };
    SignupController.prototype.prevTab = function (form) {
        if (this.selectedTab <= 0) {
            this.selectedTab = 0;
        }
        else {
            this.selectedTab = (this.selectedTab - 1);
        }
    };
    SignupController.prototype.isFormValid = function () {
        if (this.isAccountFormValid && this.isProfessionalFormValid && this.isAccountFormValid) {
            return true;
        }
        if (this.selectedTab == 0 && this.isAccountFormValid) {
            return true;
        }
        return false;
    };
    SignupController.prototype.upload = function (credentials, method) {
        var self = this;
        var uploadError = false;
        var uploadPromises = [];
        var uploadDeferred = [];
        var requestType = method;
        var uploadUrl = '';
        for (var i = 0; i < credentials.length; i++) {
            var credential = credentials[i];
            if (!credential.$error && credential.file && credential.credentialType != null && credential.status != 'UPLOADED') {
                if (!self.progressBar)
                    self.progressBar = true;
                var xsrf_token = this.$cookies.get('XSRF-TOKEN');
                self.$cookies.put('credentialUploaded', 'true'); // for confirmation page
                uploadDeferred[i] = { id: credential.id, deferred: this.$q.defer() };
                uploadPromises.push(uploadDeferred[i].deferred.promise); // for credential upload
                if (requestType == 'PUT') {
                    uploadUrl = "/api/account/credentials/" + credential.credentialId;
                }
                else {
                    uploadUrl = "/api/account/credentials";
                    requestType = 'POST';
                }
                self.Upload.upload({
                    url: uploadUrl, method: requestType, headers: {
                        'X-XSRF-TOKEN': xsrf_token
                    }, data: {
                        id: credential.id,
                        doctorTypeId: credential.credentialType.doctorTypeID,
                        doctorTypeKey: credential.credentialType.doctorTypeKey,
                        file: credential.file
                    }
                }).then(function (resp) {
                    self.$timeout(function () {
                        if (credential.file) {
                            self.log = 'file: ' + resp.config.data.id + ' ----> ' + JSON.stringify(resp.config.data) + ', Response: ' + JSON.stringify(resp.data);
                            console.log(self.log);
                        }
                        if (resp.status != 200 || (resp.data && resp.data.errors && resp.data.errors.length)) {
                            console.log('File Upload Failed ->', resp);
                            uploadError = true;
                            //self.formSubmitted = false;
                            //credential.status = 'UPLOAD FAILED';
                            //self.Util.handleApiError(resp, self);
                        }
                        else {
                            credential.status = 'UPLOADED';
                        }
                        for (var j = 0; j < uploadDeferred.length; j++) {
                            if (uploadDeferred[j].id == resp.config.data.id) {
                                uploadDeferred[j].deferred.resolve();
                                break;
                            }
                        }
                    });
                }, function (resp) {
                    self.loadingBar = false;
                    self.formSubmitted = false;
                    uploadError = true;
                    if (resp.status != 200 || (resp.data && resp.data.errors && resp.data.errors.length)) {
                        credential.status = 'UPLOAD FAILED';
                        //self.Util.handleApiError(resp, self);
                    }
                    console.log('Error status: ' + resp.status);
                    console.log('Error : ', resp);
                    console.log('Error Uploading ->', credential.file, ' Resolved Promise for ->', credential);
                    credential.status = 'UPLOAD FAILED';
                    for (var j = 0; j < uploadDeferred.length; j++) {
                        if (uploadDeferred[j].id == resp.config.data.id) {
                            uploadDeferred[j].deferred.resolve();
                            break;
                        }
                    }
                }, function (evt) {
                    self.progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                    if (credential.file) {
                        self.log = 'progress: ' + self.progressPercentage + '% ' + evt.config.data.file.name + '\n' + self.log;
                        console.log(self.log);
                    }
                    credential.status = 'UPLOADING';
                });
            }
        }
        self.$q.all(uploadPromises).then(function () {
            if (uploadError) {
                self.$cookies.put('credentialUploadError', 'true'); // for confirmation page
                // Save current credentials list with errors so that resubmit can omit successful submissions
                // self.prevCredentials = angular.copy(self.credentials);
            }
            self.Util.resetApiError(self);
            self.showSimpleToast('Successful', '');
            self.loadingBar = false;
            self.Util.resetApiError(self);
            // After successful credential upload:
            self.$state.go('signupConfirmed');
            console.log('******^^^^^^^^^^^^^^^^Setting Progress Bar FALSE^^^^^^^^^^^^^^^^^^^^^');
            self.progressBar = false;
            uploadPromises.length = 0;
        });
    };
    SignupController.prototype.fireEvent = function (eventName) {
        this.signupService.fireEvent(eventName);
    };
    SignupController.prototype.validateFormAndFireError = function (fieldName, errorName, exceptionProperties) {
        if (exceptionProperties === void 0) { exceptionProperties = []; }
        var field = this.$scope.addrForm[fieldName];
        if (!field)
            return;
        for (var error in field.$error) {
            if (exceptionProperties.indexOf(error) === -1 && field.$error.hasOwnProperty(error) && field.$error[error]) {
                this.fireEvent(errorName);
                return;
            }
        }
    };
    SignupController.prototype.fireButtonClickEvent = function (elementId, eventName, errorName) {
        var button = document.getElementById(elementId);
        if (!button)
            return;
        if (button.disabled === false)
            this.fireEvent(eventName);
        if (button.disabled === true)
            this.fireEvent(errorName);
    };
    return SignupController;
}());
export default SignupController;
//# sourceMappingURL=signup.controller.js.map